// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_km1","cls2":"Header-cls2_VqW Header-cls1_km1"};